import React from "react";
import { TFunction } from "next-i18next";
import Categories from "./Categories";
import Classes from "./[categoryId]/Classes";
import { BookableCategory } from "../../lib/skillsHub";
import { INLINE_SINGLE_CATEGORY } from "../../constants/skillsHub";

// The bookable Skills Hub classes, as /skills-hub and the signed-in homepage
// both show them: with one bookable category (and INLINE_SINGLE_CATEGORY), that
// category's classes directly; with more, the category grid. Renders nothing
// when no category is bookable, so each page decides what to show instead.
const BookableClasses = ({ t, bookable, headingTag = "h2" }: Props) => {
  if (!bookable.length) return null;

  if (!(INLINE_SINGLE_CATEGORY && bookable.length === 1)) {
    return (
      <Categories
        t={t}
        categories={bookable.map((entry) => entry.category)}
        headingTag={headingTag}
      />
    );
  }

  const { category, classes } = bookable[0];
  const Heading = headingTag;
  const headingId = `skills-hub-category-${category.lcCategoryId}`;

  return (
    <section aria-labelledby={headingId}>
      <Heading id={headingId} style={{ padding: "35px 0 5px", fontWeight: "600" }}>
        {category.lcCategoryName}
      </Heading>
      {category.lcCategoryDesc && <p>{category.lcCategoryDesc}</p>}
      <Classes classes={classes} />
    </section>
  );
};

interface Props {
  t: TFunction;
  bookable: BookableCategory[];
  // The level of the category heading: h2 where it heads the page's content,
  // h3 where the page puts its own section heading above it.
  headingTag?: "h2" | "h3";
}

export default BookableClasses;
